import { Dispatch, SetStateAction, useContext } from 'react'

import { ShotlistsService } from '@/services/shotlist.service'

import { DraftsContext } from '@/features/Home/components/shotlistUpload/DraftsContext'
import { validateShotlistUploadFile } from '@/features/Home/helpers/validateShotlistUploadFile'
import { ITask } from '@/types/task.interface'
import { toastError } from '@/utils/toastError'

export interface IUploadFile {
	taskId: string
	file: File
}

interface IUseCreateShotlistDraftsParams {
	setFiles: Dispatch<SetStateAction<IUploadFile[]>>
}

export const useCreateShotlistDrafts = ({
	setFiles
}: IUseCreateShotlistDraftsParams) => {
	const { addDraft } = useContext(DraftsContext)

	const createDraft = async (file: File) => {
		if (!validateShotlistUploadFile(file)) {
			toastError('You can only choose MP3, MP4 or MOV files!')
			return
		}

		const { id: taskId } = await ShotlistsService.createShotlistTask(file.name)
		setFiles(prev => [...prev, { taskId, file }])

		const shotlistRes = await ShotlistsService.getShotlist(taskId)
		addDraft(shotlistRes as unknown as ITask)
	}

	const createDrafts = async (selectedFiles: File[]) => {
		for (const file of selectedFiles) {
			await createDraft(file)
		}
	}

	return {
		createDrafts
	}
}
